import {Injectable} from '@angular/core';
import Pusher from 'pusher-js';

import {environment} from '../../environments/environment';
import {BehaviorSubject, Subject} from 'rxjs';

import {pusherChannels as pccChannels, eventTypes as pccEventTypes, releaseChannels as releaseChannels} from '../constants/pcc_webhook_constants';

const REHAB_REPORTS_RESULT_NOTIFICATION_CHANNEL = 'REHAB_REPORTS_RESULT_NOTIFICATION_CHANNEL'

@Injectable({
    providedIn: 'root'
})
export class PusherService {

    public pusher: any;
    note: any;
    private new_note = new BehaviorSubject({name: 'note'});
    public note_notify = this.new_note.asObservable();
    private new_dictation = new BehaviorSubject({name: 'dictation'});
    public dictation_notify = this.new_dictation.asObservable();

    private new_pcc_webhook = new BehaviorSubject(null);
    public pcc_webhook_notify = this.new_pcc_webhook.asObservable();
    
    private new_rehab_reports = new BehaviorSubject(null);
    public new_rehab_reports_notify = this.new_rehab_reports.asObservable();

    private new_release = new BehaviorSubject(null);
    public new_release_notify = this.new_release.asObservable();
    newReleaseNotficationReceive: Subject<any> = new Subject<any>();
    
    constructor() {
        this.pusher = new Pusher(environment.PUSHER.API_KEY, {
            cluster: environment.PUSHER.CLUSTER
        });
        const note = this.pusher.subscribe('NOTE_CREATION');
        note.bind('new-note', (data) => {
            this.new_note.next(data);
        });
        const dictationChannel = this.pusher.subscribe('NEW_DICTATION');
        dictationChannel.bind('new-dictation', (data) => {
            this.new_dictation.next(data);
        });
        // const newRelease = this.pusher.subscribe('NEW_RELEASE');
        // newRelease.bind('new_release', (data) => {
        //     this.new_release.next(data);
        // })
        // this.subscribeChannels();
    }

    subscribeChannels() {
        
        this.note = this.pusher.subscribe('NOTE_CREATION');
        this.note.bind('new-note', (data) => {
            
            this.new_note.next(data);
        });
        const dictationChannel = this.pusher.subscribe('NEW_DICTATION');
        dictationChannel.bind('new-dictation', (data) => {
            
            this.new_dictation.next(data);
        });
    }

    subscribeVersionChannels() {
        const channel = this.pusher.subscribe('version-update');
        channel.bind('version-event', (data) => {
            console.log(data);
            // alert('hello =>' + data);
        });
    }

    subscribeToRehabReportsNotificationChannel = (doc_id, eventTypes) => {
        const channel = this.pusher.subscribe(`${REHAB_REPORTS_RESULT_NOTIFICATION_CHANNEL}.${doc_id}`);

        for(let event_type of eventTypes) {
            
            channel.bind(event_type, (data) => {
                this.new_rehab_reports.next({
                    event_type,
                    payload: data
                });
            });
        }
        return channel;
    }
    subscribePCCWebhookNotificationChannel = (user_id, eventTypes) => {
        const channel = this.pusher.subscribe(`${pccChannels.PCC_WEBHOOK_NOTIFICATION_CHANNEL}.${user_id}`);

        for(let event_type of eventTypes) {
            
            channel.bind(event_type, (data) => {
                this.new_pcc_webhook.next({
                    event_type,
                    payload: data
                });
            });
        }
        return channel;
    }

    subscribeNewReleaseChannel = (eventTypes) => {
        const channel = this.pusher.subscribe(`${releaseChannels.NEW_RELEASE_CHANNEL}`);
        for(let event_type of eventTypes){
            channel.bind(event_type, (data) => {
                this.new_release.next({
                    event_type,
                    payload: data
                })
            })
        }
        return channel;
    }

    getNoteCreationChannel() {
        const channel = this.pusher.subscribe('NOTE_CREATION');
        return channel;
    }

    getDictationCreationChannel() {
        const channel = this.pusher.subscribe('NEW_DICTATION');
        return channel;
    }
}
